var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallClockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "schedule_FILL0_wght400_GRAD0_opsz48",
    d: "M10.837,11.413l.563-.562-1.988-2V6.338h-.75V9.15ZM9,14a4.838,4.838,0,0,1-1.937-.394,5.038,5.038,0,0,1-2.669-2.669,4.964,4.964,0,0,1,0-3.875A5.038,5.038,0,0,1,7.063,4.394a4.964,4.964,0,0,1,3.875,0,5.038,5.038,0,0,1,2.669,2.669,4.964,4.964,0,0,1,0,3.875,5.038,5.038,0,0,1-2.669,2.669A4.838,4.838,0,0,1,9,14ZM9,9Zm0,4.25A4.091,4.091,0,0,0,12,12a4.091,4.091,0,0,0,1.25-3A4.091,4.091,0,0,0,12,6,4.091,4.091,0,0,0,9,4.75,4.091,4.091,0,0,0,6,6,4.091,4.091,0,0,0,4.75,9,4.091,4.091,0,0,0,6,12,4.091,4.091,0,0,0,9,13.25Z",
    transform: "translate(-4 -4)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallClockIcon);
export default __webpack_public_path__ + "static/media/SmallClockIcon.bf46fc624e7f24f9f04e54e7a0c88512.svg";
export { ForwardRef as ReactComponent };